import React, { useEffect } from "react";
import { useParams } from "react-router-dom";
import articlesStore from "../../../store/articles/ArticlesStore";
import CircularProgress from "@material-ui/core/CircularProgress";
import { DragDropContext, Draggable, Droppable } from "react-beautiful-dnd";
import List from "@material-ui/core/List";
import ModifiergroupDraggable from "./ModifiergroupDraggable";
import Button from "@material-ui/core/Button";
import cloudStore from "../../../store/CloudStore";
import Typography from "@material-ui/core/Typography";
import { getArticles } from "../../../store/articles/ArticlesApi";
import { updateModifierarticles } from "../../../store/articles/ModifierarticlesApi";
import { sortOnPriority } from "../../../store/articles/ArticlesHelpers";
import { Modifiergroup } from "../../../store/articles/models/Modifiergroup";
import withIntl from "../../../utils/withIntl";
import { Paper } from "@material-ui/core";
import Grid from "@material-ui/core/Grid";
import SearchBox from "../SearchBox";
import ExpandMoreIcon from "@material-ui/icons/ExpandMore";
import { ExpandLess } from "@material-ui/icons";
import { makeStyles } from "@material-ui/core/styles";
import { updateModifiergroups } from "../../../store/articles/ModifiergroupsApi";
import TranslationSelection from "../../TranslationSelection/TranslationSelection";

const useStyles = makeStyles((theme) => ({
  rootButton: {
    fontSize: 12,
    padding: 2,
  },
  // section: { border: "2px solid black" },
}));

function ModifiergroupMenu(props) {
  const classes = useStyles();
  const merchantId = Number.parseInt(useParams().merchantId);
  const modifiergroupIdParam = new URLSearchParams(props.location.search).get("modifiergroupId");
  const [modifiergroups, setModifiergroups] = React.useState(null);
  const [expandedModifiergroups, setExpandedModifiergroups] = React.useState([]);
  const [searchValueParam, setSearchValueParam] = React.useState(
    new URLSearchParams(props.location.search).get("searchValue")
  );
  const [searchValue, setSearchValue] = React.useState(searchValueParam != null ? searchValueParam : "");
  const [currentLanguage, setCurrentLanguage] = React.useState(cloudStore.merchant.default_language);

  const handleExpansion = (modifiergroupId) => {
    if (expandedModifiergroups.includes(modifiergroupId)) {
      // remove
      const newExpandedModifiergroups = [...expandedModifiergroups];
      newExpandedModifiergroups.splice(
        newExpandedModifiergroups.findIndex((id) => id === modifiergroupId),
        1
      );
      setExpandedModifiergroups(newExpandedModifiergroups);
    } else {
      //add
      const newExpandedModifiergroups = [...expandedModifiergroups, modifiergroupId];
      setExpandedModifiergroups(newExpandedModifiergroups);
    }
  };

  useEffect(() => {
    let newSearchValueParam = new URLSearchParams(props.location.search).get("searchValue");
    if (searchValueParam !== newSearchValueParam) {
      setSearchValue(newSearchValueParam);
      setSearchValueParam(newSearchValueParam);
    }
  });

  const onChangeModifiergroups = () => {
    if (articlesStore.modifiergroups != null) {
      if (modifiergroups == null && modifiergroupIdParam != null) {
        handleExpansion(parseInt(modifiergroupIdParam));
      }
      setModifiergroups(
        sortOnPriority(
          Object.keys(articlesStore.modifiergroups).map(
            (modifiergroupKey) => articlesStore.modifiergroups[modifiergroupKey]
          )
        )
      );
    } else {
      setModifiergroups(null);
    }
  };

  useEffect(() => {
    articlesStore.on(articlesStore.events.MENU_UPDATED, onChangeModifiergroups);
    return () => {
      articlesStore.removeListener(articlesStore.events.MENU_UPDATED, onChangeModifiergroups);
    };
  }, []);

  useEffect(() => {
    if (merchantId !== articlesStore.merchantId) {
      if (modifiergroups != null) {
        setModifiergroups(null);
      }
      getArticles(merchantId);
    } else if (modifiergroups == null && articlesStore.modifiergroups != null) {
      onChangeModifiergroups();
    }
  }, []);

  if (!modifiergroups) {
    return (
      <div align="center">
        <CircularProgress color="primary" />
      </div>
    );
  }
  if (modifiergroups.length === 0) {
    return <div>{props.intl.formatMessage({ id: "no_options_found" })}</div>;
  }

  const handleExpandAll = () => {
    let newExpanded = [...expandedModifiergroups];
    modifiergroups.forEach((modifiergroup) => {
      if (!expandedModifiergroups.includes(modifiergroup.id)) {
        newExpanded.push(modifiergroup.id);
      }
    });
    setExpandedModifiergroups(newExpanded);
  };

  const handleCollapseAll = () => {
    setExpandedModifiergroups([]);
  };

  const onDragEnd = (result) => {
    if (!result.destination) {
      return;
    }

    if (result.type === "MODIFIERGROUP") {
      let newModifiergroups = [...modifiergroups];

      const oldIndex = result.source.index;
      const newIndex = result.destination.index;

      newModifiergroups.splice(newIndex, 0, newModifiergroups.splice(oldIndex, 1)[0]);

      for (let i = 0; i < newModifiergroups.length; i++) {
        newModifiergroups[i] = Object.assign(new Modifiergroup(), newModifiergroups[i]);
        newModifiergroups[i].priority = 1000 - i;
      }
      newModifiergroups.sort((a, b) => b.priority - a.priority);

      setModifiergroups(newModifiergroups);
      updateModifiergroups(
        articlesStore.merchantId,
        newModifiergroups,
        newModifiergroups.map((modifiergroup) => ({
          priority: modifiergroup.priority,
        }))
      ).catch(() => {
        onChangeModifiergroups();
      });
    } else if (result.type === "MODIFIERARTICLE") {
      let newModifiergroups = [...modifiergroups];

      const sourceModifiergroupId = parseInt(result.source.droppableId.split("-")[2]);
      const destinationModifiergroupId = parseInt(result.destination.droppableId.split("-")[2]);
      if (sourceModifiergroupId !== destinationModifiergroupId) {
        return;
      }

      const oldIndex = result.source.index;

      const newIndex = result.destination.index;

      const sourceModifiergroupIndex = newModifiergroups.findIndex(
        (modifiergroup) => modifiergroup.id === sourceModifiergroupId
      );

      const destinationModifiergroupIndex = newModifiergroups.findIndex(
        (modifiergroup) => modifiergroup.id === destinationModifiergroupId
      );

      let destinationModifierarticles = newModifiergroups[destinationModifiergroupIndex].getModifierarticles(
        articlesStore.modifierarticles
      );
      let sourceModifierarticles = destinationModifierarticles;
      if (destinationModifiergroupIndex !== sourceModifiergroupIndex) {
        sourceModifierarticles = newModifiergroups[sourceModifiergroupIndex].getModifierarticles(
          articlesStore.modifierarticles
        );
      }

      let targetModifierarticle = sourceModifierarticles.splice(oldIndex, 1)[0];

      destinationModifierarticles.splice(newIndex, 0, targetModifierarticle);

      let newData = [];
      let oldData = [];
      for (let i = 0; i < destinationModifierarticles.length; i++) {
        oldData[i] = {
          priority: destinationModifierarticles[i].priority,
          modifiergroupId: destinationModifierarticles[i].modifiergroupId,
        };
        destinationModifierarticles[i].priority = 1000 - i;
        destinationModifierarticles[i].modifiergroupId = destinationModifiergroupId;
        newData[i] = { priority: 1000 - i, modifiergroupId: destinationModifierarticles[i].modifiergroupId };
      }

      if (destinationModifiergroupIndex !== sourceModifiergroupIndex) {
        newModifiergroups[sourceModifiergroupIndex].modifierarticleIds = newModifiergroups[
          sourceModifiergroupIndex
        ].modifierarticleIds.filter((modifierarticleId) => modifierarticleId !== targetModifierarticle.id);
        newModifiergroups[destinationModifiergroupIndex].modifierarticleIds.push(targetModifierarticle.id);
      }
      setModifiergroups(newModifiergroups);
      updateModifierarticles(articlesStore.merchantId, destinationModifierarticles, newData, oldData);
    }
  };

  let filteredModifiergroups = [...modifiergroups];
  if (searchValue.length > 0) {
    filteredModifiergroups = filteredModifiergroups.reduce((filtered, modifiergroup) => {
      try {
        // articlegroup = { ...articlegroup };
        if (modifiergroup.name && modifiergroup.name.toLowerCase().includes(searchValue.toLowerCase())) {
          filtered.push(modifiergroup);
          return filtered;
        }

        let modifierarticles = modifiergroup
          .getModifierarticles(articlesStore.modifierarticles)
          .filter((modifierarticle) => {
            if (
              (modifierarticle.name && modifierarticle.name.toLowerCase().includes(searchValue.toLowerCase())) ||
              modifierarticle.plu.toLowerCase().includes(searchValue.toLowerCase())
            ) {
              modifierarticle.hide = false;
              return true;
            } else {
              modifierarticle.hide = true;
              return false;
            }
          });
        if (modifierarticles.length > 0) {
          filtered.push(modifiergroup);
          return filtered;
        } else {
          return filtered;
        }
      } catch (e) {
        return filtered;
      }
    }, []);
  } else {
    if (articlesStore.modifierarticles != null) {
      Object.keys(articlesStore.modifierarticles).forEach(
        (modifierarticleId) => (articlesStore.modifierarticles[modifierarticleId].hide = false)
      );
    }
  }

  return (
    <div>
      <Typography gutterBottom variant="h5" style={{ textAlign: "left" }}>
        {props.intl.formatMessage({ id: "option_articles" })} - {cloudStore.merchant?.name}
      </Typography>
      <Paper>
        <Grid container alignItems={"center"}>
          <Grid className={classes.section} item xs={10} sm={10} md={5} lg={5}>
            <SearchBox
              searchValue={searchValue}
              onChange={(value) => {
                setSearchValue(value);
              }}
            />
          </Grid>

          <Grid className={classes.section} item xs={2} sm={2} md={2} lg={4}>
            <TranslationSelection
              currentLanguage={currentLanguage}
              handleClickLanguage={(language) => setCurrentLanguage(language)}
            />
          </Grid>
          <Grid className={classes.section} item xs={12} sm={12} md={5} lg={3}>
            <div style={{ display: "flex", justifyContent: "flex-end", paddingRight: 20 }}>
              <Button
                classes={{ root: classes.rootButton }}
                onClick={handleExpandAll}
                style={{ marginRight: "5px" }}
                variant="standard"
                endIcon={<ExpandMoreIcon />}
              >
                {props.intl.formatMessage({ id: "expand_all" })}
              </Button>
              <Button
                endIcon={<ExpandLess />}
                classes={{ root: classes.rootButton }}
                onClick={handleCollapseAll}
                variant="standard"
              >
                {props.intl.formatMessage({ id: "collapse_all" })}
              </Button>
            </div>
          </Grid>
        </Grid>
        <DragDropContext key={currentLanguage} onDragEnd={onDragEnd}>
          <Droppable type="MODIFIERGROUP" droppableId={"droppable-modifiergroups"}>
            {(provided) => (
              <List innerRef={provided.innerRef} {...provided.droppableProps}>
                {filteredModifiergroups.map((modifiergroup, modifiergroupIndex) => (
                  <Draggable
                    type="MODIFIERGROUP"
                    draggableId={"draggable-modifiergroup-" + modifiergroup.id}
                    key={modifiergroup.id}
                    index={modifiergroupIndex}
                  >
                    {(provided, snapshot) => {
                      return (
                        <ModifiergroupDraggable
                          setSearchValue={setSearchValue}
                          provided={provided}
                          snapshot={snapshot}
                          expandedModifiergroups={expandedModifiergroups}
                          modifiergroup={modifiergroup}
                          handleExpansion={handleExpansion}
                          hideDragHandles={searchValue.length > 0}
                          currentLanguage={currentLanguage}
                          setCurrentLanguage={setCurrentLanguage}
                        />
                      );
                    }}
                  </Draggable>
                ))}
                {provided.placeholder}
              </List>
            )}
          </Droppable>
        </DragDropContext>
      </Paper>
    </div>
  );
}

export default withIntl(ModifiergroupMenu);
